import { render, staticRenderFns } from "./WebhookManagement.vue?vue&type=template&id=c2404e92&scoped=true&"
import script from "./WebhookManagement.vue?vue&type=script&lang=js&"
export * from "./WebhookManagement.vue?vue&type=script&lang=js&"
import style0 from "./WebhookManagement.vue?vue&type=style&index=0&id=c2404e92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2404e92",
  null
  
)

export default component.exports